export class WebWorker {
  worker: Worker;

  constructor(worker: () => void) {
    const code = worker.toString();
    const blob = new Blob([`(${code})()`]);
    this.worker = new Worker(URL.createObjectURL(blob));
  }
}
